import App from './App.svelte';

export function build(target, endpoint, validDpEndpoints = [], fromUrl = "") {
    return new App({
        target: target,
        props: {
            endpoint: endpoint,
            validDpEndpoints: validDpEndpoints,
            fromUrl: fromUrl
        }
    });
}
